import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { SourceSystemRepository } from '@front/repository/Api/SourceSystem';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';

import Project = AuthDomain.Object.Project;

import { sourceSystemQueryKeys } from './queryKeys';

const repository = new SourceSystemRepository();

type Options = {
  enabled?: boolean;
};

export const _list = (projectId: Project.Id, options?: Options) => {
  return useQuery({
    queryKey: sourceSystemQueryKeys.list(projectId),
    queryFn: async ({ signal }) => {
      return repository.list({ projectId }, { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) });
    },
    enabled: options?.enabled ?? true,
    ...UseQueryDefaultOptions,
  });
};
